import { clomp } from 'clomp';

export const Center = clomp.div`
  flex
  items-center
  justify-center
`;
